import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RouterLink} from '@angular/router';

/**
 * ### NlrPaginationComponent
 * ---
 * Inputs
 * - `collectionSize` - The number of items in your paginated collection.
 * - `maxSize` - The maximum number of pages to display. Default 0.
 * - `page` - The current page.
 * - `pageSize` - The number of items per page.
 * ---
 * Outputs
 * - `pageChange` - An event fired when the page is changed. Will fire only if
 *   collection size is set and all values are valid. Event payload is the number
 *   of the newly selected page.
 */
@Component({
    selector: 'nlr-pagination',
    imports: [RouterLink],
    templateUrl: './nlr-pagination.component.html',
    styleUrl: './nlr-pagination.component.scss'
})
export class NlrPaginationComponent {
    @Input() collectionSize: number;
    @Input() maxPageCount: number = 0;
    @Input() pageSize: number;
    @Input() currentPage: number;
    @Output() pageChange = new EventEmitter<number>();
    pageCount = 0;
    start = 0;
    end = 0;

    pageRouterLinkPath: string = '/plan-dashboard';

    pages() {
        this.pageCount = Math.ceil(this.collectionSize / this.pageSize);

        const arr: number[] = [];
        for (let i = 1; i <= this.pageCount; i++) {
            arr.push(i);
        }

        if (this.maxPageCount === 0) {
            return [...arr]; // show all
        } else {
            this.calculateStartEnd();
            const rArr: any[] = [...arr.slice(this.start, this.end)];
            // console.log(`start: ${rArr[0]}, end: ${rArr[rArr.length - 1]}`);

            if (rArr[0] > 1) {
                if (rArr[0] > 2) {
                    rArr.unshift('…');
                }
                rArr.unshift(1);
            }
            const lastPage = rArr[rArr.length - 1];
            if (lastPage < this.pageCount) {
                if (lastPage < this.pageCount - 1) {
                    rArr.push('…');
                }
                rArr.push(this.pageCount);
            }
            return rArr;
        }
    }

    private calculateStartEnd() {
        this.start =
            this.currentPage < this.maxPageCount - 1
                ? 0
                : this.currentPage > this.pageCount - 3
                  ? this.pageCount - this.maxPageCount
                  : this.currentPage - 3;
        this.end = this.start + this.maxPageCount;
    }

    onPageClick(value) {
        this.currentPage = value;
        this.calculateStartEnd();
        this.pageChange.emit(value);
    }

    nextPage() {
        if (this.currentPage < this.pageCount) {
            this.onPageClick(this.currentPage + 1);
        }
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.onPageClick(this.currentPage - 1);
        }
    }

    firstPage() {
        this.onPageClick(1);
    }

    lastPage() {
        this.onPageClick(this.pageCount);
    }
}
